// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import asyncMergeSort from "async-merge-sort";

export const sortData = (arr, { asc, col }, callback) => {
  const sorter = (a, b, cb) => {
    let av;
    let bv;

    switch (col) {
      // this value is a number. sort on it as a number
      case "projectIndex":
        av = a[col];
        bv = b[col];
        break;

      case "numberOfPaths":
        av = Number(a[col] ?? 0);
        bv = Number(b[col] ?? 0);
        break;

      case "createTime":
        av = a.createTimestamp;
        bv = b.createTimestamp;
        break;

      case "modifiedTime":
        av = a.lastModifiedTimestamp;
        bv = b.lastModifiedTimestamp;
        break;

      default:
        av = a[col] !== null ? a[col].toString().toLowerCase() : "";
        bv = b[col] !== null ? b[col].toString().toLowerCase() : "";
        break;
    }

    if (asc) {
      return cb(null, av >= bv ? 1 : -1);
    } else {
      return cb(null, av <= bv ? 1 : -1);
    }
  };

  return asyncMergeSort(arr, sorter, callback);
};

// which column to sort on.
// NOTE - if you want to sort rows based on form data,
// here's where, you handle that.
export const getSortColByFormValues = (formData) => "projectIndex";
